var makeImg = function (icon) {
    var img = document.createElement('img');
    img.src = icon;
    return img;
};
var Container = /** @class */ (function () {
    function Container(ctrl) {
        this.ctrl = ctrl;
        this.loaded = false;
        this.create();
    }
    Container.prototype.update = function () {
        var sliderValue = Number(this.v_slider.value);
        this.ctrl.onSliderValueChange(sliderValue);
    };
    Container.prototype.resetLoader = function () {
        this.loaded = false;
        this.v_loader.style.display = 'none';
        this.v_buttons.style.display = 'flex';
        this.v_slider.style.display = 'none';
        this.v_title.style.display = 'none';
        this.loadPromise = null;
        this.pause();
    };
    Container.prototype.preload = function () {
        var _this = this;
        if (this.loaded)
            return true;
        this.v_buttons.style.display = 'none';
        this.v_loader.style.display = '';
        this.loaded = false;
        if (!this.loadPromise)
            this.loadPromise = this.ctrl.onPreload().then(function (n) {
                _this.v_title.style.display = '';
                _this.v_slider.style.display = '';
                _this.v_buttons.style.display = 'flex';
                _this.v_loader.style.display = 'none';
                _this.v_slider.max = String(n - 1);
                _this.loaded = true;
                return n;
            });
        return false;
    };
    Container.prototype.pause = function () {
        clearInterval(this.timer);
        this.v_pause.style.display = 'none';
        this.v_play.style.display = '';
    };
    Container.prototype.play = function () {
        var _this = this;
        this.v_play.style.display = 'none';
        this.v_pause.style.display = '';
        this.timer = setInterval(function () {
            _this.increment();
        }, 100);
    };
    Container.prototype.decrement = function () {
        if (!this.preload())
            return false;
        this.v_slider.value = String(Math.max(0, Number(this.v_slider.value) - 1));
        this.update();
        return Number(this.v_slider.min) < Number(this.v_slider.value);
    };
    Container.prototype.increment = function () {
        if (!this.preload())
            return false;
        if (Number(this.v_slider.value) == Number(this.v_slider.max)) {
            this.v_slider.value = String(0);
        }
        else {
            this.v_slider.value = String(Math.min(Number(this.v_slider.max), Number(this.v_slider.value) + 1));
        }
        this.update();
        return Number(this.v_slider.value) < Number(this.v_slider.max);
    };
    Container.prototype.setTitle = function (t) {
        this.v_title.innerHTML = t;
    };
    Container.prototype.create = function () {
        var _this = this;
        var container = (this.body = document.createElement('div'));
        container.classList.add('mapboxgl-ctrl');
        container.classList.add('mapboxgl-ctrl-group');
        container.style.padding = '10px';
        container.style.backgroundColor = '#fff';
        container.style.textAlign = 'center';
        var titleDiv = (this.v_title = document.createElement('div'));
        titleDiv.innerHTML = '';
        titleDiv.style.marginTop = '4px';
        container.appendChild(titleDiv);
        // temporal slider
        var slider = (this.v_slider = document.createElement('input'));
        slider.type = 'range';
        slider.value = '0';
        slider.min = '0';
        slider.max = String(0);
        slider.addEventListener('input', function () { return _this.update(); });
        slider.style.minWidth = '180px';
        slider.style.margin = '4px 0';
        slider.style.display = 'none';
        container.appendChild(slider);
        var buttonsDiv = document.createElement('div');
        buttonsDiv.style.display = 'flex';
        buttonsDiv.style.justifyContent = 'center';
        buttonsDiv.style.margin = '4px 0 0 0';
        this.v_buttons = buttonsDiv;
        var prevButton = document.createElement('button');
        prevButton.appendChild(makeImg(skipBackward));
        prevButton.onclick = function () { return _this.decrement(); };
        prevButton.style.border = '0';
        prevButton.style.height = '24px';
        var pauseButton = (this.v_pause = document.createElement('button'));
        pauseButton.appendChild(makeImg(pause));
        pauseButton.style.border = '0';
        pauseButton.style.height = '24px';
        pauseButton.style.display = 'none';
        pauseButton.onclick = function () { return _this.pause(); };
        var playButton = (this.v_play = document.createElement('button'));
        playButton.appendChild(makeImg(play));
        playButton.style.border = '0';
        playButton.style.height = '24px';
        playButton.onclick = function () { return _this.play(); };
        var nextButton = document.createElement('button');
        nextButton.appendChild(makeImg(skipForward));
        nextButton.style.border = '0';
        nextButton.style.height = '24px';
        nextButton.onclick = function () { return _this.increment(); };
        buttonsDiv.appendChild(prevButton);
        buttonsDiv.appendChild(pauseButton);
        buttonsDiv.appendChild(playButton);
        buttonsDiv.appendChild(nextButton);
        container.appendChild(buttonsDiv);
        var loader = (this.v_loader = document.createElement('div'));
        loader.style.width = '88px';
        loader.style.height = '28px';
        loader.style.display = 'none';
        loader.innerHTML = "<div class=\"aqspinner3\" style='height:24px'><div class=\"r1\"></div><div class=\"r2\"></div><div class=\"r3\"></div><div class=\"r4\"></div><div class=\"r5\"></div></div>";
        container.appendChild(loader);
    };
    return Container;
}());
var TemporalControl = /** @class */ (function () {
    function TemporalControl(loader) {
        this.loader = loader;
        this.cTemporalIndex = -1;
        this.container = new Container(this);
    }
    TemporalControl.prototype.resetLoader = function () {
        this.container.resetLoader();
    };
    TemporalControl.prototype.onPreload = function () {
        var _this = this;
        return this.loader().then(function (frames) {
            _this.frames = frames;
            return frames.length;
        });
    };
    TemporalControl.prototype.onAdd = function (map) {
        map.getContainer().appendChild(this.container.body);
        return this.container.body;
    };
    TemporalControl.prototype.onRemove = function () {
        var _a;
        (_a = this.container.body.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(this.container.body);
    };
    TemporalControl.prototype.getDefaultPosition = function () {
        return 'bottom-left';
    };
    TemporalControl.prototype.onSliderValueChange = function (sliderValue) {
        if (this.cTemporalIndex == sliderValue)
            return;
        this.cTemporalIndex = sliderValue;
        this.container.setTitle(this.frames[sliderValue].title);
        this.frames[sliderValue].onShow();
    };
    return TemporalControl;
}());
export { TemporalControl };
export var pause = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAABgAAAAYADwa0LPAAAAL0lEQVRIx2NgGAXDHjDikftPQC0heQYGBgYGJlr7YNSCUQtGLRi1YDBYMApGAAAAlTUCHI/K8qMAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjEtMDgtMTNUMTM6MDQ6MTMrMDA6MDBoF1fHAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIxLTA4LTEzVDEzOjA0OjEzKzAwOjAwGUrvewAAAABJRU5ErkJggg==';
export var play = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAABgAAAAYADwa0LPAAAAiklEQVRIx+3TsRFBURSE4Y8RGakSUAGRXCdaeD3oQAuaoAQaoAOhzFzRnRG8zN2RvJ3Z8Ow/58xZBg3CAdMkoOCOXRJQfcI8CSh4Yo9RClB9xjIJKHihwyQFqL5i3Tc8bnTGBbapDS5YJU7U7Jv6wpv24Tv4IdDogjeOmLUOhxs2ieCqn0o06P/6AEU0QyVw/swiAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTA4LTEzVDEzOjA0OjAyKzAwOjAwAspc7QAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0wOC0xM1QxMzowNDowMiswMDowMHOX5FEAAAAASUVORK5CYII=';
export var reload = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAABgAAAAYADwa0LPAAABRElEQVRIx+3VP0oDURAG8J9iowaCkCP4B0ErGy1io17Bg9hYGrGy0kIL9QA2khtIIt5B7a1VMGIlxGJnzRo0u5u0+WB4b3nffDM7vJnHGCNiB1d4wkfYIy6xPYrwIu7QzbE2FsqKb+I1BJ6xhyXMoYoNNDKcV9TLZJ46XqMygFvDTXBfMF8kQFqWa0wU4E+hGT6tPPJOpiyVPHIGlfDpYqv/cDKz3431VHJbiuIDZ30af+IpslgqIZ5iNXwfB5E6QaoOEWA6fDuDStSN9auEcCP8PuO7otcjR/+VaL1k9mmQrB3/RbyKw4MhSpQNcvIfaVuvM2tDBjmX0z/tCHIjaaI8TBbg/MKC3qhoYnYAt4bbyLwU6pLZknb1PlYwI7klazjEW3DeFZxD/X/Skj+u77FcVjyLLVzgQdJEndhfGPHBGeMH388+ZOzhrnnmAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTA4LTEzVDEzOjA0OjUxKzAwOjAwe8JIFAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0wOC0xM1QxMzowNDo1MSswMDowMAqf8KgAAAAASUVORK5CYII=';
export var skipBackward = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAABgAAAAYADwa0LPAAAAcElEQVRIx+2QsQ6AMAgFiXHxi11Z/eKOujhgU/Bg1L6E6ZK7piJzv9x5nzctMhTQIkMBLTIUsIIMQ4FeQBkKjASEoYAneGOPLUGoFVnqi/bglRHDAU9EGA6MRJThQC/KMBywIsxWUjQ7RGQrsLkv7wJ0tm5fRRXwUAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0wOC0xM1QxMzowNDozNCswMDowMO+VbjQAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMDgtMTNUMTM6MDQ6MzQrMDA6MDCeyNaIAAAAAElFTkSuQmCC';
export var skipForward = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAABgAAAAYADwa0LPAAAAbElEQVRIx+2QMQqAMBAEF/HPlmfpk+1io6ASzdyWmoGrBnZCpM4vWUxX9mtSXoZaDgeehojDgdoQcanAfYi4dOA8RNyFkRQlTZJWw2mAgeOFjkNfFAmXDkTSpQJhOBwI06FAmA4FZtPhQOdjbBsnZOWA27+iAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTA4LTEzVDEzOjA0OjI4KzAwOjAw5J8E3gAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0wOC0xM1QxMzowNDoyOCswMDowMJXCvGIAAAAASUVORK5CYII=';
